jQuery(function ($) {

  $(window).on('load', function () {
    let headerHeight = $('.header').outerHeight();
    let urlHash = location.hash;
    if (urlHash) {
      let position = $(urlHash).offset().top - headerHeight;
      $('html, body').animate({
        scrollTop: position
      }, 0);
    }
  });

  $('a[href^="#"]').on('click', function () {
    let time = 400;
    let header = $('.header').innerHeight();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({
      scrollTop: targetY
    }, time, 'swing');
    return false;
  });

  //MV
  var speed = 2000;
  var interval = 5000;
  var slide = $('.slider .slide');

  var count = 0;
  var length = slide.length - 1;
  setInterval(function () {
    $(slide[count]).fadeOut(speed);
    if (count >= length) {
      count = 0;
    } else {
      count++;
    }
    $(slide[count]).fadeIn(speed);
  }, interval);

  //モーダル
  $('.openModal').on('click', function () {
    var target = $(this).data('modal-link');
    var modal = document.querySelector('.' + target);
    $(modal).fadeIn();
    $('.modalBg').fadeIn();
    $('.mainbiz-gal h3').toggleClass('behind');
  });

  $('.closeModal , .modalBg').on('click', function () {
    $(this).parents('.modal').fadeOut();
  });

  //コンテンツフェードイン
  $(window).on('scroll', function () {
    $('.js-fadein').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100) {
        $(this).addClass('fadein');
      }
    });
    $('.js-fadein_slow').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100) {
        $(this).delay(500).queue(function () {
          $(this).addClass('fadein').dequeue();
        });
      }
    });
  });

  //ヘッダー
  $(window).on('scroll', function () {
    if ($('#top').length) {
      var scroll = $(window).scrollTop();
      if (scroll > 1) {
        $('header .left').addClass('is-show');
        $('.hero-main__logo').css('z-index', 'auto');
      } else {
        $('header .left').removeClass('is-show');
        $('.hero-main__logo').css('z-index', '99');
      }
    }
  });

  //ハンバーガーメニュー
  $('.menu-btn').on('click', function () {
    $('.menu-btn').toggleClass('active');
    $('nav').toggleClass('active');
    $('header').toggleClass('active');
  });

  //トップへ戻る
  $('.totop a').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var targetposition = target.offset().top;
    $('body,html').stop().animate({
      scrollTop: targetposition
    }, speed, 'linear');
    return false;
  });

  var fixedTotop = $('.totop'),
    startPosition = 0,
    timeOutId;

  $(window).on('load scroll', function () {
    var scrollValue = $(window).scrollTop();
    var mvValue = $('.mv').height();

    timeOutId = setTimeout(function () {
      if (scrollValue > mvValue) {
        fixedTotop.removeClass('is-hiden');
        fixedTotop.addClass('is-shown');
      } else {
        fixedTotop.addClass('is-hiden');
        fixedTotop.removeClass('is-shown');
      }
    }, 200);
  });

  //採用情報
  $('.recruitment-list__item dt').on('click', function () {
    $(this).next('dd').slideToggle();
    $(this).toggleClass('is-open');
  });

  //店舗情報
  $('.store .store-name').on('click', function () {
    $(this).next('.store-outline').slideToggle();
    $(this).toggleClass('is-open');
  });

  //フェードイン
  $(window).scroll(function () {
    $('.fade-in').each(function () {
      var start = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      var adjust = 200;
      if (window.matchMedia( "(max-width: 768px)" ).matches) {
        var adjust = 50;
      }
      if (scroll > start - windowHeight + adjust) {
        $(this).addClass('is-active');
      }
    });
  });

  //フォーム表示切り替え  
  $('[name="c-cat"]:radio').change(function () {
    if ($("input:radio[name='c-cat']:checked").val() == "求人応募") {
      $('.for-recruit').addClass('is-shown');
      $('.not-recruit').addClass('is-hidden');
      $(".for-general").removeClass('is-shown');
    } else if ($("input:radio[name='c-cat']:checked").val() == "一般のお問い合わせ") {
      $('.for-general').addClass('is-shown');
      $(".for-recruit").removeClass('is-shown');
      $(".not-recruit").removeClass('is-hidden');
    } else if ($("input[name='c-cat']").val() == "採用に関するご質問") {
      $(".for-recruit").removeClass('is-shown');
      $(".for-general").removeClass('is-shown');
      $(".not-recruit").removeClass('is-hidden');
    } else {
      $(".for-recruit").removeClass('is-shown');
      $(".for-general").removeClass('is-shown');
      $(".not-recruit").removeClass('is-hidden');
    }
  });

  //フォーム表示切り替え：エラー画面
  var selectedChecked = $("input[name='c-cat']:checked").val();
  if (selectedChecked == "求人応募") {
    $('.for-recruit').addClass('is-shown');
    $('.not-recruit').addClass('is-hidden');
    $(".for-general").removeClass('is-shown');
  } else if (selectedChecked == "一般のお問い合わせ") {
    $('.for-general').addClass('is-shown');
    $(".for-recruit").removeClass('is-shown');
    $(".not-recruit").removeClass('is-hidden');
  } else if (selectedChecked == "採用に関するご質問") {
    $(".for-recruit").removeClass('is-shown');
    $(".for-general").removeClass('is-shown');
    $(".not-recruit").removeClass('is-hidden');
  } else {
    $(".for-recruit").removeClass('is-shown');
    $(".for-general").removeClass('is-shown');
    $(".not-recruit").removeClass('is-hidden');
  }

  //フォーム表示切り替え：確認画面
  if (document.URL.match(/check/)) {
    var selected = $("input[name='c-cat']").val();
    if (selected == "求人応募") {
      $('.for-recruit').addClass('is-shown');
      $('.not-recruit').addClass('is-hidden');
      $(".for-general").removeClass('is-shown');
    } else if (selected == "一般のお問い合わせ") {
      $('.for-general').addClass('is-shown');
      $(".for-recruit").removeClass('is-shown');
      $(".not-recruit").removeClass('is-hidden');
    } else if (selected == "採用に関するご質問") {
      $(".for-recruit").removeClass('is-shown');
      $(".for-general").removeClass('is-shown');
      $(".not-recruit").removeClass('is-hidden');
    } else {
      $(".for-recruit").removeClass('is-shown');
      $(".for-general").removeClass('is-shown');
      $(".not-recruit").removeClass('is-hidden');
    }
  }

  //sns
  var href = location.href; //1.URLを取得しエンコードする
  var getTitle = $('title').html(); //2.ページのタイトルを取得

  //3.URLを取得しエンコードする
  var snsUrl = encodeURIComponent(href);
  var snsTitle = encodeURIComponent(getTitle);

  $('.sns_link').each(function () {
    var sns_obj = $(this).attr('id'); //4.ID名を取得
    var snsCase = sns_obj;
    //5.IDを判定してリンク先を出力する
    switch (snsCase) {
      case 'sns_tw':
        $(this).attr('href', 'http://twitter.com/share?url=' + snsUrl);
        break;

      case 'sns_fb':
        $(this).attr('href', 'http://www.facebook.com/sharer.php?u=' + snsUrl);
        break;

      case 'sns_line':
        $(this).attr('href', 'http://line.me/R/msg/text/?' + snsTitle + '%20' + snsUrl);
        break;
    }
  });

  // form 

  $('.fn-checkbox-new').on('change', () => {
    const form = $('#searchform');
    const cat = form.find('#cat');
    cat.val('');
    form.submit();
  });
  $('#searchform').on('submit', (e) => {
    const target = e.currentTarget;
    const catId = $(target).find('#cat').val();
    if (catId !== '') {
      $('.fn-checkbox-new').prop("checked", false);
    };
  });

  //
  var params = (new URL(document.location)).searchParams;
  var tag_num = params.get("tag_id");
  var cat_num = params.get("cat");
  console.log(cat_num);
  if(tag_num == 6){
    $('.search-ttl').text('新商品');
    $('.fn-checkbox-new').prop('disabled', true);
    $('.fn-checkbox-all').removeClass('is-active');
  }
  if(params == ''){
    $('.fn-checkbox-all').addClass('is-active');
  }
});